import { TooltipWrapper, TooltipBase } from "./Tooltip.styles";

export default function TooltipElement({
  tooltipContent,
  containerBounds,
  maxWidth,
  minDistance,
}: {
  tooltipContent: string | React.ReactNode;
  containerBounds: DOMRect;
  maxWidth: number;
  minDistance: number;
}) {
  const getTooltipPosition = (): Partial<DOMRect> => {
    let x = containerBounds.x + containerBounds.width / 2 - maxWidth / 2;
    let y = containerBounds.y + 25;

    if (x + maxWidth > window.innerWidth - minDistance) {
      x = containerBounds.x - maxWidth - 10;
    } else if (x < minDistance) {
      x = containerBounds.x + containerBounds.width + 10;
    }

    if (y + 50 > window.innerHeight - minDistance) {
      y = containerBounds.y - 50 - 10;
    } else if (y < minDistance) {
      y = containerBounds.y + 25;
    }

    return { x, y };
  };

  return (
    <TooltipWrapper maxWidth={maxWidth} position={getTooltipPosition()}>
      {typeof tooltipContent === "string" ? (
        <TooltipBase>{tooltipContent}</TooltipBase>
      ) : (
        tooltipContent
      )}
    </TooltipWrapper>
  );
}
